document.addEventListener('DOMContentLoaded', () => {

  const lazyLoadImage = (img) => {
    if (!img || img.dataset.loaded === 'true') return;

    let isPicture = false;

    function removeLoader(img){
      const loader = img.parentElement?.querySelector('.lazyloadt4s-loader');
      if (loader) loader.classList.remove('is--loading');
    }
  
    const picture = img.parentElement;
    if (picture && picture.tagName === 'PICTURE') {
      isPicture = true;
      const sources = picture.querySelectorAll('source[data-srcset]');
      sources.forEach(source => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
    }
  
    if (img.dataset.src) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
  
      // Set up onload listener before doing anything else
      img.onload = () => {
        removeLoader(isPicture?picture:img);
      };
    } else {
      removeLoader(isPicture?picture:img);
    }

    img.dataset.loaded = 'true';
  };
  

  const observerOptions = {
    root: null,
    threshold: 0.0001
  };

  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        lazyLoadImage(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  const observeImages = (images) => {
    images.forEach(img => {
      if (!img.dataset.loaded) {
        imageObserver.observe(img);
      }
    });
  };

  observeImages(document.querySelectorAll('img.custom-lazyload-image'));

  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches?.('img.custom-lazyload-image')) {
            observeImages([node]);
          }

          const lazyImages = node.querySelectorAll?.('img.custom-lazyload-image');
          if (lazyImages?.length) {
            observeImages(lazyImages);
          }
        }
      });
    });
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

});
